import { WidgetConfiguration } from '@widget-configs/models/widget-configuration';
import { DebtAnalysisWidgetConfiguration } from './debt-analysis-widget-configuration.model';

export class DebtAnalysisAdminWidgetConfiguration {
  WidgetConfiguration: WidgetConfiguration;
  DebtAnalysisWidgetConfiguration: DebtAnalysisWidgetConfiguration;
}
